export default __webpack_public_path__ + "static/img/14.3f5406b.png";